import * as React from 'react';
import {
  Create,
  TabbedForm,
  FormTab,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  required,
  ImageInput,
  ImageField,
  FileInput,
  FileField,
  BooleanInput,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const rawNameRegex = /[ `!@#$%^&*()+=\[\]{};':"\\|,.<>\/?~]/

const useStyles = makeStyles({
  inline: {
      display: 'inline-block',
      marginLeft: '1em',
      '&.first-child': {
          marginLeft: 0,
      },
  },
});

const LessonCreate = (props) => {
  const [divisions, setDivisions] = React.useState([]);
  const [translations, setTranslations] = React.useState([]);
  const classes = useStyles();

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/cms/divisions`)
      .then(res => res.json())
      .then(data => setDivisions(data))

    fetch(`${process.env.REACT_APP_BASE_URL}/cms/translation-keys`)
      .then(res => res.json())
      .then(({data}) => {
        if (data && data.length) {
          setTranslations(data.map((item) => item.raw_name.toLocaleLowerCase()))
        }
      })
  }, []);

  const uniqueRawName = (value) => {
    if (translations.includes(value.toLocaleLowerCase())) {
      return 'Generic name must be unique'
    }

    if (rawNameRegex.test(value)) {
      return 'Generic name should not contain: \n`!@#$%^&*()+=\[\]{};\':"\\|,.<>\/?~'
    }

    return undefined
  }

  const rawNameValidator = [required(), uniqueRawName]

  return (
    <Create title="Add lesson" {...props}>
      <TabbedForm>
        <FormTab label="summary">
          <TextInput source="name" label="Generic name" validate={rawNameValidator} formClassName={clsx(classes.inline, 'first-child')} />
          <SelectInput source="division" label="Division" choices={divisions} validate={required()} formClassName={classes.inline} />
          <NumberInput source="xp" validate={required()} formClassName={classes.inline} />
          <BooleanInput label="Premium" source="premium" />
          <DateInput label="Data de ínicio" source="date_start" formClassName={clsx(classes.inline, 'first-child')} />
          <DateInput label="Date de término" source="date_end" formClassName={classes.inline} />
          <ImageInput label="Thumbnail" source="thumbnail">
            <ImageField source="src" title="title" />
          </ImageInput>
        </FormTab>

        <FormTab label="pt-BR">
          <TextInput label="Título (pt-BR)" source="ptbr-name" validate={required()} />
          <FileInput source="ptbr-video" label="Related files" accept="video/mp4">
            <FileField source="src" title="title" />
          </FileInput>
        </FormTab>

        <FormTab label="en-US">
        <TextInput label="Título (en-US)" source="enus-name" />
        <FileInput source="enus-video" label="Related files" accept="video/mp4">
          <FileField source="src" title="title" />
        </FileInput>
        </FormTab>

        <FormTab label="es-ES">
          <TextInput label="Título (es-ES)" source="es-name" />
          <FileInput source="es-video" label="Related files" accept="video/mp4">
            <FileField source="src" title="title" />
          </FileInput>
        </FormTab>

        {/* <FormTab label="hu-HU">
          <TextInput label="Título (hu-HU)" source="hu-name" />
          <FileInput source="hu-video" label="Related files" accept="video/mp4">
            <FileField source="src" title="title" />
          </FileInput>
        </FormTab> */}
      </TabbedForm>
    </Create>
  );
}

export default LessonCreate;